import * as React from "react";
import styled from "@emotion/styled";
import breakpoint from "@/utils/breakpoint";
import FormButton from "@/components/molecules/FormButton";
import CapsuleNextButton from "@/components/molecules/CapsuleNextButton";
import ConfirmModal from "./ConfirmModal";
import withEffect, { InjectProps } from "./effect";
import { useTheme } from "@/hooks/useTheme";

type ValuationProps = Record<string, any> & React.HTMLAttributes<HTMLDivElement>;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0 0 15px;

  ${breakpoint.lessThan("sm")`
    flex-direction: column; 
  `}
`;

const WarnMessage = styled.p<{ color?: string }>`
  font-size: 14px;
  color: ${({ color = "#ff6601" }) => color};
  margin-bottom: 10px;
  text-align: center;
`;

const ValuationConfirm = ({ values, isValid, fetchValuation }: ValuationProps & InjectProps) => {
  const { isNewTheme } = useTheme();
  const handleValuation = () => {
    fetchValuation();
  };

  const [open, setOpen] = React.useState(false);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  return (
    <Wrapper>
      {!isValid && <WarnMessage color={isNewTheme ? "#ff7979" : "#ff6601"}>入力内容をご確認ください</WarnMessage>}
      <ButtonWrapper>
        {isNewTheme ? (
          <CapsuleNextButton onClick={handleOpen} minWidth="260px" disabled={!isValid} value="入力内容を確認する" className="paddingBottom" />
        ) : (
          <FormButton onClick={handleOpen} disabled={!isValid}>
            入力内容を確認する
          </FormButton>
        )}
        <ConfirmModal open={open} values={values} onValuation={handleValuation} onClose={handleClose} />
      </ButtonWrapper>
    </Wrapper>
  );
};

export default withEffect(ValuationConfirm);
